'use client';

import Bugsnag from '@bugsnag/js';
// eslint-disable-next-line @alltrails/custom/react-imports
import React, { Fragment, useEffect } from 'react';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import { debugClient } from '@alltrails/core/utils/debugClient';
import setGlobalFetchHeaders from '@alltrails/core/utils/setGlobalFetchHeaders';

const plugin = Bugsnag.getPlugin('react');
const ErrorBoundary = plugin ? plugin.createErrorBoundary(React) : Fragment;

export default function RootClientLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    debugClient({ localStorageKey: 'mugen.debug.useEffect' });
  }, []);

  const languageRegionCode = useLanguageRegionCode();
  setGlobalFetchHeaders({ languageRegionCode });

  debugClient({ localStorageKey: 'mugen.debug.layout' });

  return (
    <ErrorBoundary>
      {children}
      <div id="modalPortal" />
    </ErrorBoundary>
  );
}
